export default {"src":"/blog/_next/static/media/close.421d5f8a.svg","height":19,"width":20};